import React, { FC } from 'react';
import classNames from 'classnames';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    dark?: boolean;
    radius?: number;
}

export const PrimaryButton: FC<Props> = ({
    className,
    dark = false,
    radius,
    children,
    ...args
}) => (
    <button
        className={classNames('primary-button', className, {
            dark,
            'radius-170': radius,
        })}
        type="button"
        {...args}
    >
        {children}
    </button>
);
